import { path } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, INTRO_VIDEOS } from '../constants/state'

export const introVideos = createSelector(path([GLOBAL_STATE, INTRO_VIDEOS]), data => data)
